import { CreditCards } from '@shared/core/utils/credit-cards.utils';
import { Model } from '../model';

export class CreditCard extends Model<OLO.Members.MemberCreditCardDetails> {
    constructor(
        cardHolderName: Nullable<string>,
        paymentProvider: OLO.Enums.PAYMENT_PROVIDER,
        number: string,
        cvv: Nullable<string>,
        type: OLO.Enums.CREDIT_CARD_TYPES,
        expiryDate: string,
        token: string,
        isDefault: boolean,
        saveCard: boolean,
        validationStatus: OLO.Types.VALIDATION_STATUS,
        LocationNo: number,
        id: number | string,
        fatZebraToken: OLO.DTO.NullableFatZebraTokenVerification,
        adyenPaymentData: Adyen.PaymentData,
        stripePaymentData: OLO.DTO.StripeResponsePaymentMethod,
        billingDetails: Nullable<OLO.CreditCards.CreditCardBillingDetails>,
    ) {
        super();

        this._model.PaymentProvider = paymentProvider;
        this._model.ExpirationDate = CreditCards.dateToApiFormat(expiryDate);
        this._model.CardType = type;
        this._model.Token = token;
        this._model.Id = id;
        this._model.IsDefault = isDefault;
        this._model.SaveAwait = saveCard;
        this._model.ValidationStatus = validationStatus;
        this._model.LocationNo = LocationNo;
        this._model.FatZebraToken = fatZebraToken;
        this._model.AdyenPaymentData = adyenPaymentData;
        this._model.StripePaymentData = stripePaymentData;

        if (cardHolderName) {
            this._model.CardHolderName = cardHolderName;
        }

        if (cvv) {
            this._model.Cvv = cvv;
        }

        if (number) {
            this._model.CardNumber = number;
        }

        if (number && number.substring) {
            this._model.DisplayName = this._model.NiceName = number.substring(number.length - 4);
        }

        if (billingDetails) {
            this._model.BillingDetails = billingDetails;
        }
    }
}
